import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import { MdClose } from "react-icons/md";
import { DEFAULT_LANGUAGE } from "src/helpers/constants";
import useCurrentUser from "src/hooks/useCurrentUser";
import { useState } from "react";
import clsx from "clsx";
import RadioGroup from "../RadioGroup/RadioGroup";
import CustomSelect from "../Select/CustomSelect";
import useLanguages from "src/hooks/useLanguages";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface IEmailSettingsModal {
  onClose: () => void;
}

const EmailSettingsModal: React.FC<IEmailSettingsModal> = ({ onClose }) => {
  const { t } = useTranslation();
  const { allLanguagesSelect } = useLanguages();
  const { settings } = useCurrentUser();
  const [emailLanguage, setEmailLanguage] = useState<string>(
    settings?.notifications?.emailNotifications?.language || DEFAULT_LANGUAGE,
  );
  const [emailNotifications, setEmailNotifications] = useState<boolean>(
    !!settings?.notifications?.emailNotifications?.enabled,
  );

  return (
    <Modal
      onEscape={onClose}
      className={clsx(["md:!max-w-[430px]", "md:!w-full"])}
    >
      <Modal.Header
        title="Configurar notificaciones por correo"
        onClose={onClose}
      />
      <Modal.Body>
        <div
          className={clsx(["flex", "w-full", "flex-col", "gap-4", "md:gap-6"])}
        >
          <div className={clsx(["flex", "w-full", "md:text-sm", "text-sm"])}>
            {t("modals:notifications.email.collapsible.description")}
          </div>
          <RadioGroup
            onChange={(value: any) => setEmailNotifications(value)}
            columns={2}
            selected={emailNotifications}
            options={[
              {
                value: true,
                label: t("modals:notifications.email.collapsible.enable"),
              },
              {
                value: false,
                label: t("modals:notifications.email.collapsible.disable"),
              },
            ]}
          />
          {emailNotifications && (
            <>
              <CustomSelect
                options={allLanguagesSelect}
                label={t(
                  "modals:notifications.email.collapsible.inputs.language.label",
                )}
                isClearable={false}
                value={emailLanguage}
                useValueAsLabel={false}
                onChange={(e: any) => {
                  setEmailLanguage(e?.value || "");
                }}
                helpText={t(
                  "modals:notifications.email.collapsible.inputs.language.help_text",
                )}
              />
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: onClose,
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
          },
        ]}
      />
    </Modal>
  );
};

export default EmailSettingsModal;
